  export default [
    { 
      key: '1',
      sourceField: '',
      sourceDataType: '',
      sourceDataFormat: '',
      transform: 'Static: "Exampleville PD"',
      targetField: 'agency_name',
      targetDataFormat: '',
      sampleInput: '',
    },
    {
      key: '2',
      sourceField: 'date',
      sourceDataType: 'dateTime',
      sourceDataFormat: 'M/D/YY HH:mm',
      transform: 'DateTime: M/D/YY HH:mm -> YYYY-MM-DD',
      targetField: 'stop_date',
      targetDataFormat: 'YYYY-MM-DD',
      sampleInput: '10/3/18 14:17',
    },
    {
      key: '3',
      sourceField: 'date',
      sourceDataType: 'dateTime',
      sourceDataFormat: 'M/D/YY HH:mm',
      transform: 'DateTime: M/D/YY HH:mm -> HH:mm',
      targetField: 'stop_time',
      targetDataFormat: 'HH:mm',
      sampleInput: '12/18/18 9:29',
    },
    {
      key: '4',
      sourceField: 'dob',
      sourceDataType: 'date',
      sourceDataFormat: 'date',
      transform: 'DateTime to Age: M/D/YY -> Age',
      targetField: 'age_of_individual_stopped',
      targetDataFormat: '',
      sampleInput: '',
    },
    {
      key: '5',
      sourceField: 'race',
      sourceDataType: 'string',
      sourceDataFormat: '',
      transform: 'Enumeration: Native -> I, A -> A, AA -> B (3 more)',
      targetField: 'race_of_individual_stopped',
      targetDataFormat: '',
      sampleInput: '',
    },
  ]



// WEBPACK FOOTER //
// ./src/data.js